import React from 'react';
import { Link } from 'react-router-dom';
import { ProjectDTO } from '../DTO/ProjectDTO';
import { StatusLabel } from './StatusLabel';
import { assetUrl } from '../config/config';
import { OptionalImage } from './OptionalImage';

interface Props {
    project: ProjectDTO;
}

export const FeaturedProjectPreview: React.FC<Props> = ({ project }) => (
    <article className="group flex flex-col overflow-hidden rounded border border-rule bg-surface transition-colors hover:border-muted">
        {project.thumbnailUrl && (
            <OptionalImage
                src={assetUrl(project.thumbnailUrl)}
                alt=""
                className="w-full h-full object-cover"
                frame={img => <div className="h-48 overflow-hidden border-b border-rule bg-paper">{img}</div>}
            />
        )}

        <div className="flex flex-1 flex-col gap-3 p-5">
            <h3 className="text-xl m-0">
                <Link to={`/projects/${project.slug}`} className="hover:text-loden">
                    {project.name}
                </Link>
            </h3>

            <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                <StatusLabel status={project.status} />
                {project.technologies?.slice(0, 4).map(t => (
                    <span key={t.id} className="tag">{t.name}</span>
                ))}
                {project.technologies?.length > 4 && (
                    <span className="label">+{project.technologies.length - 4} more</span>
                )}
            </div>

            <p className="flex-1 text-muted text-base line-clamp-3 m-0">
                {project.description}
            </p>

            <Link to={`/projects/${project.slug}`} className="link font-label self-start">
                View project<span className="sr-only">: {project.name}</span>
            </Link>
        </div>
    </article>
);
